<template lang="pug">

  v-app.sosBodyBackground(:class="{ capsLock: userSession.userProfile.capsLock || false /* $store.state.app.userSession.userProfile.capsLock || false */ }")

    confirm-dialog(ref="cdConfirmModal" :title="cdParameters.title" :text="cdParameters.text" :buttonPosition="cdParameters.buttonPosition" :width="cdParameters.width" @close="cdAction")

    //- JESUS
    //- JESUS
    //- JESUS

    //- v-overlay(:value="userSession.loading")
        v-progress-circular(indeterminate size="64")

    sos-version

    drawer
    app-bar

    .mainWrapper

      v-container(fluid)

        banner.appBanner(v-if="whiteLabel === false")
        router-view
        sos-footer

</template>

<script>

  import { mapState/* , mapMutations */ } from 'vuex'

  import { whiteLabel } from '@/constants'

  import { apiLogout } from '@/services/index.js'

  import confirmDialogMixin from '@/mixins/cd.mixin.js'

  import ConfirmDialog from '@/modals/ConfirmDialog'

  import SosVersion from '@/components/SosVersion'
  import Banner from './Banner'
  import Drawer from './Drawer'
  import AppBar from './AppBar'
  import Footer from './Footer'

  export default {
    name: 'DashboardLayout',

    components: {
      'sos-version': SosVersion,
      drawer: Drawer,
      'app-bar': AppBar,
      banner: Banner,
      'sos-footer': Footer,
      'confirm-dialog': ConfirmDialog,
    },

    mixins: [
      confirmDialogMixin,
    ],

    head: {
      // creates a title tag in header.
      title () {
        return {
          inner: 'Painel - Gestor SOS Plantão',
        }
      },

      meta: [
        { name: 'description', content: 'Painel do Gestor para SOS Plantão', id: 'desc' }, // id to replace intead of create element

        // Twitter
        { name: 'twitter:title', content: 'Painel - Gestor SOS Plantão' },
        // with shorthand
        { n: 'twitter:description', c: 'Painel do Gestor do SOS Plantão' },

        // Google+ / Schema.org
        { itemprop: 'name', content: 'Painel - Gestor SOS Plantão' },
        { itemprop: 'description', content: 'Painel - Gestor SOS Plantão' },

        // Facebook / Open Graph
        { property: 'og:title', content: 'Painel - Gestor SOS Plantão' },
      ],
    },

    data: () => ({
      whiteLabel,
    }),

    computed: {
      ...mapState({
        userSession: state => state.app.userSession,
        dialogLogout: state => state.app.dialogLogout,
      }),
    },

    watch: {
      '$store.state.app.dialogLogout': {
        deep: true,
        immediate: true, // the callback will be called immediately after the start of the observation
        handler (newDialogLogoutStatus, oldDialogLogoutStatus)
        {
          if (!!oldDialogLogoutStatus === false && !!newDialogLogoutStatus === true) {
            // [24/01/25] console.log('::: index.vue')

            this.showConfirmBox({ title: 'Atenção!', text: 'Você deseja encerrar sua sessão no SOS Gestor?', type: 'doLogout', data: '', isResponse: false, buttonPosition: 'right', width: 330, closeText: 'Não', continueText: 'Sair!' })
          }

          /* if (!!oldDialogLogoutStatus === true && !!newDialogLogoutStatus === false) {
            // [24/01/25] console.log('::: THE LOGOUT CONFIRMATION DIALOG IS CLOSED')
          } */
        },
      },
    },

    methods: {
      /* ...mapMutations({ askLogout: 'ASK_LOGOUT' }), */

      async cdAction (cdResponse)
      {
        this.$store.commit('ASK_LOGOUT', false)
        // this.askLogout(false)

        if (cdResponse === false) return

        if (cdResponse.cdType === 'doLogout') apiLogout()
      },
    },
  }

</script>

<style lang="sass" scoped>

  .mainWrapper
    padding-left: 80px
    padding-top: 75px

  .sosBodyBackground
    background-color: #EDE8FE !important

  .appBanner
    margin-bottom: 50px

  @media (max-width: 960px)
    .mainWrapper
      padding-left: 0

</style>
